import type { RentalManagerAuthCheckUserInfoDto } from '@zg-rentals/ts-rental-manager-api-client';
import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';
import { normalizeUser } from '../user';

export const useRentalManagerUser = () => {
  const { environment, setEnvironment } = React.useContext(RentalManagerEnvironmentContext);
  const user = React.useMemo(() => {
    return environment.user;
  }, [environment.user]);

  const updateUser = (newUser: RentalManagerAuthCheckUserInfoDto) => {
    setEnvironment({
      ...environment,
      user: newUser,
      initialAuthComplete: true,
    });
  };

  const logOut = () => {
    setEnvironment({
      ...environment,
      user: normalizeUser(),
    });
  };

  return { user, updateUser, logOut };
};
